const audio = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'audio'
    },
    censorshipTableData: {},
    issuesData: {}
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default audio
